import { render, staticRenderFns } from "./TemplateProdutos.vue?vue&type=template&id=cce4d022&"
import script from "./TemplateProdutos.vue?vue&type=script&lang=js&"
export * from "./TemplateProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports